<template lang="pug">
modal#cancel-envelope-modal(
  :no-footer='true'
  :title='$t("modal.cancelEnvelope.title")'
  ref='modal'
  size='sm'
)
  p.justify-center {{ $t('modal.cancelEnvelope.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/envelope-cancel.svg')
  .text-end
    button.btn.btn-secondary(@click='close' type='button') {{ $t('modal.cancelEnvelope.keepButton') }}
    button.btn.btn-danger.ms-2(
      @click='cancelEnvelope'
      style='border-width: 1px'
      type='button'
    ) {{ $t('modal.cancelEnvelope.cancelButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import RecipientsService from '@/modules/business/services/http/envelopes/RecipientsService';
import alert from '@/modules/account/common/alert';

export default {
  name: 'CancelEnvelopeModal',
  props: {
    envelopeId: [Number, String],
  },
  components: {
    Modal,
  },
  methods: {
    close() {
      if (this.$refs.modal) {
        this.$refs.modal.close();
      }
    },
    cancelEnvelope() {
      this.$loading(true);
      if (this.$route.params.token) {
        RecipientsService.rejectEnvelope(this.$route.params.token)
          .then((response) => {
            this.$nextTick(() => {
              this.$emit('refresh', response);
            });
          })
          .catch((error) => {
            alert.fireAlert(
              `${this.$t('modal.cancelEnvelope.error')} ${
                error.response.data.message
              }`,
              {
                classes: 'alert-danger',
                styles:
                  'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
                tag: 'httpAlert',
                icon: 'triangle-exclamation',
              }
            );
          })
          .finally(() => {
            this.close();
            this.$loading(false);
          });
      } else {
        EnvelopesService.cancelEnvelope(this.envelopeId)
          .then(() => {
            this.$nextTick(() => {
              this.$emit('refresh');
            });
          })
          .catch((error) => {
            alert.fireAlert(
              `${this.$t('modal.cancelEnvelope.error')} ${
                error.response.data.message
              }`,
              {
                classes: 'alert-danger',
                styles:
                  'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
                tag: 'httpAlert',
                icon: 'triangle-exclamation',
              }
            );
          })
          .finally(() => {
            this.close();
            this.$loading(false);
          });
      }
    },
  },
};
</script>
